/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductSpecificationViewProps } from './pdp-specs';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const ECO_MATERIALS_ATTRIBUTE_NAME = 'data-eco-materials';

    React.useEffect(() => {
        window.addEventListener('click', function(event) {
            const el = event.target as HTMLAnchorElement;
            const ecoMatAttr = el.attributes.getNamedItem(ECO_MATERIALS_ATTRIBUTE_NAME);
            if (ecoMatAttr) {
                event.preventDefault();
                const ecoMat = ecoMatAttr ? ecoMatAttr.nodeValue : '';
                if (ecoMat) {
                    props.openModal(ecoMat);
                }
            }
        });
    }, []);

    const {
        ProductSpecification,
        ProductSpecificationTableProps,
        ProductSpecificationTableBodyProps,
        productSpecificationResult,
        modal
    } = props;
    const rowdata =
        productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult.filter(row => !ObjectExtensions.isNullOrUndefined(row));

    return rowdata && ArrayExtensions.hasElements(rowdata) ? (
        <Module {...ProductSpecification}>
            {props.title}
            <Node {...ProductSpecificationTableProps}>
                <Node {...ProductSpecificationTableBodyProps}>{rowdata}</Node>
            </Node>
            {modal}
        </Module>
    ) : null;
};

export default ProductSpecificationView;
